import React from 'react';
import { Panel } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import CandidatePhoto from '../../CandidatePhoto/CandidatePhoto';
import { Desktop } from '../../../hoc/Responsive';
import './candidateReview.css';

const getFullName = (firstname, lastname) => {
  const reviewName = firstname || lastname ? firstname + ' ' + lastname : "Not Specified";
	return reviewName;
}

/**
 * @desc Review candidate details
 * @param props
 * @return null
 */
const CandidateReview = (props) => {
  const fullName = getFullName(props.candidate_fname, props.candidate_lname);
  const SelectedCandidates = (props.selectedCandidates && props.selectedCandidates.some(item => item === props.candidate_id)) ? "Selected" : 'Select';  

	return (
    <Panel className={'pool-card draggable '+ SelectedCandidates} onClick={() => props.handleCandidateSelect(props.candidate_id)}>
			<Panel.Body>
				<div className="candidate-head">
          <div className="profile-picture">
          <CandidatePhoto 
            initials={props.initials} 
            candidatePhoto={props.s3SignedUrl} 
          />
          </div>
				  <div className="title"><span>{fullName}</span></div>
        </div>
        <div className="position-company-main">
          <div className="position" title= {(props.current_job_title) ? props.current_job_title : 'Actively Seeking Employment' }>
            {(props.current_job_title) ? 
              props.current_job_title :
              'Actively Seeking Employment' 
            }
          </div>
          <div className="position-company" title= {(props.current_employer) ? props.current_employer : '' }>
            {(props.current_employer) ? 
              props.current_employer : 
              "" 
            }
          </div>
          </div>
        <Desktop>
          {props.footerRemove?null:<div className="footer">
            <Button 
              value={props.id} 
              onClick={()=>props.handleCandidateSelect(props.candidate_id)} 
            >View</Button>
          </div>}
        </Desktop>
			</Panel.Body>
    </Panel>
	);
}

export default CandidateReview;


// WEBPACK FOOTER //
// ./src/components/Client/CandidateReview/CandidateReview.js